import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './8bb9413bdd14fb51d5d29cbdf0609528177aa9a6e776e76866c59fac1d57e03b.cfe-internal.js';
import '../../icons/index.es.js';
import { useNumberStepperContext } from './cab259ea986bae84b53c604411632728b26d185d6bd5f24fb5bdb7d35490dde4.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';
import AddIcon from '../../icons/components/4adf08b4e6a41c64a8b4bbf099f3296bdacbb84ca004ec15fc24ee01371bc1ef.cfe-internal.js';

var _excluded = ["data-testid", "className", "onClick"];
/**
 * Renders the NumberStepperIncrement component.
 * Either `NumberStepper` renders this component automatically or the consumer renders this component explicitly.
 */
var NumberStepperIncrement = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var dataTestIdFromProps = _ref['data-testid'],
    className = _ref.className,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;

  // Context from NumberStepper
  var _useNumberStepperCont = useNumberStepperContext(),
    isExternallyDisabled = _useNumberStepperCont.isExternallyDisabled,
    dataTestId = _useNumberStepperCont.dataTestId,
    increment = _useNumberStepperCont.increment,
    inputValue = _useNumberStepperCont.inputValue,
    max = _useNumberStepperCont.max;

  // Indicates if the button is disabled
  var isDisabled = inputValue >= max || isExternallyDisabled;

  /**
   * Calls `onClick` if it is defined.
   * Calls `increment`.
   */
  var handleClick = function handleClick(e) {
    if (!isDisabled) {
      onClick === null || onClick === void 0 || onClick(e);
      increment(true);
    }
  };
  return /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    "data-testid": dataTestIdFromProps !== null && dataTestIdFromProps !== void 0 ? dataTestIdFromProps : getSubDataTestId(dataTestId, 'Increment'),
    ref: ref,
    type: "button",
    className: classNames(className, styles.incrementBtn, _defineProperty({}, styles.disabled, isDisabled)),
    onClick: handleClick,
    "aria-disabled": isDisabled,
    "aria-label": translate('increment'),
    tabIndex: -1
  }), /*#__PURE__*/React__default.createElement(AddIcon, {
    size: "small",
    "aria-hidden": "true"
  }));
});

export { NumberStepperIncrement as default };
